import { render, staticRenderFns } from "./FlashCardSide.vue?vue&type=template&id=7a48048f&scoped=true&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCard/FlashCardSide?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCard/FlashCardSide?vue&type=script&lang=js&"
import style0 from "./FlashCardSide.vue?vue&type=style&index=0&id=7a48048f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a48048f",
  null
  
)

export default component.exports